import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    maxWidth: theme.spacing(120),
  },
  actions: {
    padding: theme.spacing(2),
  },
}));

export default useStyles;
